import {FunctionComponent, HTMLProps} from 'react';
import {twMerge} from 'tailwind-merge';
import ContainerCardContent from './content';
import ContainerCardHeader from './header';

interface ContainerCardComponent extends FunctionComponent<HTMLProps<HTMLDivElement>> {
  Header: typeof ContainerCardHeader;
  Content: typeof ContainerCardContent;
}

const ContainerCard: ContainerCardComponent = ({children, className, ...props}) => {
  return (
    <div className={twMerge('relative grow rounded-4 bg-white px-8 pb-12', className)} {...props}>
      {children}
    </div>
  );
};

ContainerCard.Header = ContainerCardHeader;
ContainerCard.Content = ContainerCardContent;

export default ContainerCard;
